import { render, staticRenderFns } from "./EditPriceDialog.vue?vue&type=template&id=58538a3a&scoped=true"
import script from "./EditPriceDialog.vue?vue&type=script&lang=js"
export * from "./EditPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58538a3a",
  null
  
)

export default component.exports